module.exports = __webpack_public_path__ + "img/stick_hebergements_chambre_hote.2f788c60.svg";